import Icon from '@mdi/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getSelectedIconColor,
  getSelectedIconName,
  getSelectedIconSize,
  setSelectedIconColor,
  setSelectedIconName,
  setSelectedIconSize,
  setSelectedTool,
} from '../../../store/lixaniPaint/slices/drawingToolSlice';
import { ICON_OPTIONS, getIconByName } from './iconOptions';

export const IconSelectionDialog = ({ isOpen, onClose, context }) => {
  const dispatch = useDispatch();
  const selectedIconName = useSelector(getSelectedIconName);
  const selectedIcon = getIconByName(selectedIconName);
  const selectedIconSize = useSelector(getSelectedIconSize);
  const selectedIconColor = useSelector(getSelectedIconColor);

  const firestopIcons = ['map-marker'];
  const effectiveIcons =
    context === 'location_placement'
      ? ICON_OPTIONS.filter((i) => firestopIcons.includes(i.name))
      : ICON_OPTIONS;

  const handleConfirmSelection = () => {
    onClose();
    dispatch(setSelectedTool('icon'));
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#1687af',
          padding: '24px',
          borderRadius: '12px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          minWidth: '400px',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          style={{
            color: 'white',
            margin: 0,
            fontSize: '18px',
            fontWeight: '600',
            textAlign: 'center',
          }}
        >
          Valitse ikoni
        </h3>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          {effectiveIcons.map((icon) => (
            <button
              key={icon.name}
              onClick={() => dispatch(setSelectedIconName(icon.name))}
              style={{
                padding: '16px',
                border:
                  selectedIconName === icon.name
                    ? '2px solid white'
                    : '2px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '8px',
                backgroundColor:
                  selectedIconName === icon.name
                    ? 'rgba(255, 255, 255, 0.2)'
                    : 'rgba(255, 255, 255, 0.1)',
                color: 'white',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease',
                minWidth: '80px',
              }}
            >
              <Icon path={icon.icon} size={2} color="white" />
              <span style={{ fontSize: '12px', fontWeight: '500' }}>
                {icon.displayName}
              </span>
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              justifyContent: 'space-between',
            }}
          >
            <span
              style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}
            >
              Koko: {selectedIconSize.toFixed(1)}x
            </span>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100px',
                height: '100px',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                overflow: 'hidden',
              }}
            >
              <Icon
                path={selectedIcon.icon}
                size={selectedIconSize}
                color={selectedIconColor}
              />
            </div>
          </div>
          <input
            type="range"
            min="0.5"
            max="3"
            step="0.1"
            value={selectedIconSize}
            onChange={(e) =>
              dispatch(setSelectedIconSize(parseFloat(e.target.value)))
            }
            style={{
              width: '100%',
              height: '8px',
              borderRadius: '4px',
              background: 'rgba(255, 255, 255, 0.3)',
              outline: 'none',
              cursor: 'pointer',
              WebkitAppearance: 'none',
            }}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <span style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}>
            Väri:
          </span>
          <div
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {[
              '#000000',
              '#ffffff',
              '#ff0000',
              '#00ff00',
              '#0000ff',
              '#ffff00',
              '#ff00ff',
              '#00ffff',
              '#ffa500',
              '#800080',
            ].map((color) => (
              <button
                key={color}
                onClick={() => dispatch(setSelectedIconColor(color))}
                style={{
                  width: '32px',
                  height: '32px',
                  backgroundColor: color,
                  border:
                    selectedIconColor === color
                      ? '3px solid white'
                      : '2px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
              />
            ))}
          </div>
        </div>
        <button
          onClick={handleConfirmSelection}
          style={{
            padding: '12px 32px',
            backgroundColor: 'white',
            color: '#1687af',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            alignSelf: 'center',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          Valitse
        </button>
      </div>
    </div>
  );
};
